import {
    LabelLarge,
} from 'baseui/typography';
import { Breadcrumbs } from 'baseui/breadcrumbs';
import { StyledLink } from "baseui/link";
import { BasePageLayout } from './Page/BasePageLayout';
import { Link } from 'react-router-dom';
import { useStyletron } from 'baseui';


export type LinkProps = {
    name: string,
    href: string,
    isCurrent: boolean
}
export interface HierarchyPageProps {
    header: string,
    children: any,
    links: LinkProps[],
    actionButton?: any,
    showNavigateBack?: boolean | undefined
}

const HierarchyPage = (props: HierarchyPageProps) => {
    return (
        <BasePageLayout
            children={props.children}
            header={props.header}
            subheader={<MyBreadCrumbs data={props.links}></MyBreadCrumbs>}
            actionButton={props.actionButton}
            showNavigateBack={props.showNavigateBack}></BasePageLayout>
    )
}


export default HierarchyPage;


const MyBreadCrumbs = ({ data }: any) => {
    const [css, theme] = useStyletron();
    return (
        <>
            <Breadcrumbs overrides={{
                ListItem: {
                    style: ({ $theme }) => ({
                        fontSize: $theme.typography.ParagraphXSmall.fontSize
                    })
                }
            }}>
                {data?.map((item: any, index: number) => {
                    if (item.isCurrent)
                        return (
                            <span key={index}>{item.name}</span>
                        )
                    else
                        return (
                            <Link key={index}  to={item.href} className={css({ textDecoration: 'none' })}>
                                <StyledLink animateUnderline >{item.name}</StyledLink>
                            </Link>
                        )
                })}
            </Breadcrumbs>
        </>
    )
}

